import { render, staticRenderFns } from "./AuthView.vue?vue&type=template&id=266c1bd9&"
import script from "./AuthView.vue?vue&type=script&lang=ts&"
export * from "./AuthView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports